import cls from 'clsx';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { Left } from '@linktivity/link-icons';
import Logo from '@link/portal/assets/logo.svg?react';
import { LIMOUSINE_SUPPLIER_ID } from '@link/portal/views/Limousine/constants';

import styles from './header.module.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const supplierId = pathname.split('/')[2];
  const isLimousine = supplierId === LIMOUSINE_SUPPLIER_ID;

  return (
    <header className={cls(styles.header, isLimousine && styles.limousine)}>
      <div className={styles.inner}>
        {isLimousine && (
          <button
            type="button"
            className={styles.back}
            aria-label={t('common.back')}
            onClick={() => navigate(-1)}
          >
            <Left className={styles.backIcon} />
          </button>
        )}
        <Logo className={styles.logo} />
      </div>
    </header>
  );
};

export default Header;
